// Ported from Grove's Common/Kendo/kendo_common.js, which was a full set of
// Kendo widget wrappers (KendoTextField, KendoDropDown, KendoGrid, etc.) for
// the literally-ported dynamicForm.js. dynamicForm.js was the "Form Preview"
// feature and has since been removed (dead code, zero importers), and
// nothing else in this app ever used the rest of that file — clearForm is
// the one function FormBuilderField.js still calls (Edit Field modal's
// Cancel/close flow), so everything else was dropped rather than keep
// ~2,470 lines of unused widget wrappers around.
//
// jQuery is loaded globally via <script> in public/index.html (before Kendo),
// same as LabBookingGantt.js's `window.$ || window.jQuery` pattern — bound
// once here so `$` resolves for ESLint's no-undef instead of relying on an
// implicit global.
const $ = window.$ || window.jQuery;

export const clearForm = (formID, setData) => {
  const form = document.getElementById(formID);
  if (form) {
    var validator = $(`#${formID}`).kendoValidator().data("kendoValidator");
    validator.reset();
    form.reset();
  }
  if (setData) {
    setData({});
  }
};
